import { GameEvents } from 'Utility/GameEvent/GameEvents';

declare global {
    interface Window {
        gameEvents: GameEvents;
    }
}

export function createGameEmitter(): void {
    window.gameEvents = new GameEvents();
}

export function getGameEmitter(): GameEvents {
    return window.gameEvents;
}
